<template>
  <div id="drawingHeader" v-show="isShow">
    <div class="drawingHeader__normal drawingHeaderUI">
      <div class="drawingHeaderUI__left">
        <ClearCanvasUI></ClearCanvasUI>
      </div>
      <div class="drawingHeaderUI__center">
        <HistoryUI></HistoryUI>
      </div>
      <div class="drawingHeaderUI__right">
        <div
          class="buttonMini buttonMini--80 button--primaryColor drawingHeaderUI__next"
          :class="{ 'button--disable': !savable }"
          @click="next"
        >
          OK
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DrawEvent } from "../../events/DrawEvent";
import * as drawEventType from "../../events/DrawEventType";
import * as modeTypes from "../../store/modules/mode/types";
import { isModeDraw, isToolText } from "../../util/StoreUtil";
import * as textTypes from "../../store/modules/tool/types";
import ClearCanvasUI from "./ClearCanvasUI";
import HistoryUI from "./HistoryUI";
export default {
  name: "DrawingHeaderUI",
  components: {
    ClearCanvasUI,
    HistoryUI
  },
  computed: {
    savable() {
      return this.$store.state.canvas.savable;
    },
    isShow() {
      return isModeDraw() && !isToolText();
    },
    isModeTextTrans() {
      return (
        this.$store.state.tool.text.state == textTypes.TEXT_STATE_TRANSFORM
      );
    },
    history() {
      return this.$store.state.history;
    },
    isActiveBack() {
      return this.history.index > 0;
    },
    isActiveForward() {
      return this.history.index + 1 < this.history.length;
    }
  },
  methods: {
    clearCanvas() {
      DrawEvent.emit(drawEventType.CLEAR_CANVAS);
    },
    next() {
      this.$store.dispatch(
        modeTypes.namespace + modeTypes.SET_MODE,
        modeTypes.MODE_PUBLISH
      );
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/common"
@import "../../sass/zindex"
@import "../../sass/colors"
#drawingHeader
  position: absolute
  z-index: $z_header_ui
  width: 100%
  .drawingHeader__normal
    position: relative
    padding: 17px 15px 0
    width: 100%
    @include flexCenter()
    justify-content: space-between

  .drawingHeaderUI__center
    margin-right: -36px
    @include flexCenter()
    .buttonMini:first-child
      margin-right: 16px
  .drawingHeaderUI__right
    margin-top: -1px
</style>
